import React from 'react'
import { useIntl } from 'react-intl'

import PriceLayout, { FeaturedPrice } from '../../../PriceLayout'
import { OfferPriceProps } from '..'

const OfferPriceNetTotal = ({
  className,
  board,
  nights,
  priceData,
  prime = false,
  showDiscount,
  showDiscountBadge,
  showSubtitle,
  showFrom,
  loading = false,
}: OfferPriceProps) => {
  const intl = useIntl()

  const {
    currency,
    discount,
    pricePerNightSubtotal,
    initialPrice,
    subtotal,
    taxDetails,
    additionalFees,
    insuranceSelected,
  } = board

  return (
    <PriceLayout
      className={className}
      currency={currency}
      discount={discount}
      pricePerNight={pricePerNightSubtotal}
      priceInitial={initialPrice}
      priceFinal={subtotal}
      vats={intl.formatMessage({ id: 'global.taxes-fees-not-inc' })}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      nights={nights}
      featuredPrice={FeaturedPrice.Total}
      loading={loading}
      showSubtitle={showSubtitle}
      taxDetails={taxDetails}
      additionalFees={additionalFees}
      insuranceSelected={insuranceSelected}
    />
  )
}

export default OfferPriceNetTotal
